<template>
  <nav class="d-flex" id="menusuperior">
    <h1 v-if="!tituloVinculo.activo">{{titulo}}</h1>
    <!-- <h1 :class="[(tituloVinculo.activo) ? 'titulo-vinculo-cursor' : '']" @click="irAVinculoInterno({ nombrePath: tituloVinculo.pathName })">{{titulo}}</h1> -->
    <div v-if="$route.name != 'modulosAudienciasTemporal' && tituloVinculo.activo" class="pl-4 pr-4">
      <button type="button" @click="irAVinculoInterno({ nombrePath: 'modulosAudienciasTemporal' })" class="btn btn-sm btn-light"><i class="fas fa-chevron-circle-left"></i>&nbsp;&nbsp;ir a menú principal</button>
    </div>
    <span></span>
    <h3 class="d-none d-sm-none d-md-none d-lg-block">{{subtitulo}}</h3>
    <div class="d-flex align-items-center w-50 justify-content-end">
      <div id="user" class="d-flex align-items-center w-50 justify-content-end">
        <figure id="user-photo" class="d-flex align-items-center justify-content-center">
          <span id="pj-iniciales" v-if="fotoDelUsuario == null">{{iniciales}}</span>
          <img src="" alt="Foto del usuario" v-else />
        </figure>
        <p id="username" class="mb-0 d-none d-sm-none d-md-none d-lg-block">{{tituloYNombreCompleto}}</p>
      </div>
      <div id="recargardatosdelasesion" class="d-none align-items-center justify-content-end" v-on:click="recargarDatosDeLaSesion()">
        <i id="recargandodatosdelasesion" class="fas fa-sync-alt"></i>
        <span id="mensajededatosdelasesion">Recarga la sesión</span>
      </div>
      <div id="dirigiralogin" class="d-none align-items-center justify-content-end" v-on:click="irALogin()">
        &nbsp;&nbsp;&nbsp;<i class="fas fa-user-times"></i>
        <span id="mensajededatosdelasesion">&nbsp;&nbsp;Iniciar sesión</span>
      </div>
      <router-link id="tablero" class="align-items-center justify-content-end d-none" title="Regresa al menú de bienvenida" to="/Tablero/Bienvenida">
        <i class="fas fa-th-large"></i>
      </router-link>
      <div id="notificacion" class="d-none align-items-center justify-content-end" title="Notificación">
        <i class="far fa-bell"></i>
      </div>
      <div id="ayuda" class="d-flex align-items-center justify-content-end"  title="Ayuda" @mouseover="mostrarAyuda = true" @mouseleave="mostrarAyuda = false" v-bind:class="{ 'menu-seleccionado': mostrarAyuda }">
        <i class="fas fa-question-circle"></i>
        <div class="listado-de-ayuda" v-if="mostrarAyuda == true">
          <ul>
            <li v-for="ayuda in listadoDeAyuda" :key="ayuda.Nombre">
              <a v-on:click="AbrirDocumento(ayuda.Ruta)" class=""><i class="fas fa-file-download"></i>&nbsp;&nbsp;&nbsp;{{ayuda.Nombre}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div id="cerrarsesion" class="d-none align-items-center justify-content-end" title="Cerrar sesión" v-on:click="validarCerrarSesion()" >
        <i class="fas fa-sign-out-alt"></i>
      </div>
      <div id="seccionDerecha" class="d-none d-sm-none d-md-none d-lg-block">
      </div>
    </div>
    <cargandoInformacion :props="'cargandoInformacion_div'"></cargandoInformacion>
    <contrasenanovalidada></contrasenanovalidada>
  </nav>
</template>

<script>
  import cargandoInformacion from '../../../src/components/Comunes/CargandoInformacion.vue'
  import contrasenanovalidada from '../../../src/components/Comunes/ContrasenaNoValidada.vue'
  import comun from '@/../static/js/comun'
  import router from '@/router/index'
  import { mapActions } from 'vuex'

  export default {
    name: 'App',
    components: {
      cargandoInformacion,
      contrasenanovalidada
    },
    data() {
      return {
        fotoDeUsuario: true, 
        mostrarAyuda: false
      }
    },
    computed: {
      tituloYNombreCompleto() {
        return this.$store.state.Login_Usuario.TituloYNombreCompleto;
      },
      iniciales() {
        return this.$store.state.Login_Usuario.Iniciales;
      },
      fotoDelUsuario() {
        return this.$store.state.Login_Usuario.Foto;
      }, 
      listadoDeAyuda() {
        return this.$store.state.Login_ListadoDeAyuda;
      },
    },
    async mounted() {
      this.recargarDatosDeLaSesion();
      this.validarQueLaSesionSigaActiva();
    },
    props: {
      titulo: String,
      subtitulo: String,
      tituloVinculo: {
          type: Object,
          default: () => ({
            activo: false,
            pathName: null
          })
      }
    },
    methods: {
      irAVinculoInterno: function({ nombrePath }) { debugger
          if(this.tituloVinculo != null && this.tituloVinculo != undefined && this.tituloVinculo.activo) {
            this.$router.push({ name: nombrePath });
          }
      },
      validarQueLaSesionSigaActiva: function() {
        if(this.$store.state.TiempoDeVerificacionId != null)
          clearInterval(this.$store.state.TiempoDeVerificacionId);

        this.$store.state.Login_TiempoDeVerificacionId = setInterval(async () => {
            this.recargarDatosDeLaSesion()
          }, 600000);
      },
      recargarDatosDeLaSesion: async function() {
        const parametros = {
          CargaInformacionDePaginaActual: true
        }

        await this.A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema(parametros);
      },
      validarCerrarSesion: function() {
        const parametrosDeConfirmacion = {
          mensaje: "Esta a punto de cerrar sesión.<br />¿Desea finalizar su sesión?",
          textoDeCancelacion: "Cancelar",
          textoDeConfirmacion: "Cerrar sesión",
          nombreDeFuncionSi: "this.cerrarSesion",
          datosSi: null,
          nombreDeFuncionNo: null,
          datosNo: null
        };

        this.A_ConfirmacionParaCerrarSesion(parametrosDeConfirmacion);
      },
      irALogin: function() {
        router.push({ path: '/Login' });
      },
      AbrirDocumento: function(vinculo, formaDeApertura = "_self") {
        window.open(vinculo, formaDeApertura);
      },
      ...mapActions([
        'A_ConfirmacionParaCerrarSesion',
        'A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema'
      ])
    }
  }
</script>

<style scoped>

  .titulo-vinculo-cursor {
    cursor: pointer;
  }
  
  nav {
    position: fixed;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    left: 0;
    background: linear-gradient(rgb(126,127,116), rgb(126,127,116));
    color: #FFF;
    height: 60px;
    z-index: 10;
  }

  h1 {
    border-right: 1px solid #222222;
    padding: 0px 20px;
    font-size: 30px;
    margin-bottom: 0;
    min-width: 200px;
  }

  h3 {
    font-size: 20px;
    padding: 0 20px;
    margin-bottom: 0;
    width: 50%;
  }

  #pj-logo {
    width: 90px;
    margin-bottom: 0;
    padding-left: 20px;
  }

  #pj-iniciales {
    font-size: large;
    font-weight: 700;
  }

  #user {
    height: 60px;
    display: flex;
    justify-content: flex-start;
  }

  #user-photo {
    min-width: 40px;
    min-height: 40px;
    margin-bottom: 0;
    border-radius: 50%;
    overflow: hidden;
    margin: 10px 3.5px;
    background-color: whitesmoke;
    color: #363638;
    text-align: center;
  }

  .fa-sync-alt {
    font-size: 15px;
    padding-right: 10px;
    padding-left: 10px;
  }

  #username {
    padding-right: 60px;
    font-weight: bold;
    margin-left: 3.5px;
  }

  #recargardatosdelasesion {
    height: 60px;
    transition: all .3s;
  }

    #recargardatosdelasesion:hover {
      background-color: #333333;
      cursor: pointer;
    }

  #mensajededatosdelasesion {
    padding-right: 60px;
    font-weight: bold;
    margin-left: 3.5px;
  }

  #dirigiralogin {
    height: 60px;
    transition: all .3s;
  }

    #dirigiralogin:hover {
      background-color: #333333;
      cursor: pointer;
    }

  #tablero {
    height: 60px;
    transition: all .3s;
  }

    #tablero:hover {
      background-color: #333333;
      cursor: pointer;
    }

  .fa-th-large {
    color: #FFF;
    font-size: 20px;
    padding-right: 10px;
    padding-left: 10px;
  }

  #notificacion {
    height: 60px;
    transition: all .3s;
  }

    #notificacion:hover {
      background-color: #333333;
      cursor: not-allowed;
    }

  .fa-bell {
    font-size: 20px;
    padding-right: 10px;
    padding-left: 10px;
  }

  #ayuda {
    height: 60px;
    transition: all .3s;
  }

    #ayuda:hover {
      background-color: #333333;
      cursor: pointer;
    }

  .listado-de-ayuda {
    position: fixed;
    top: 60px;
    right: 0;
    background-color: #45454c;
    min-width: 150px;
  }

    .listado-de-ayuda ul {
      margin: 0 0 0 0;
      padding: 0;
    }

      .listado-de-ayuda ul li {
        padding: 10px;
        list-style: none;
        cursor: pointer;
      }

      .listado-de-ayuda ul li:hover {
        background-color: #333333;
      }

        .listado-de-ayuda ul li a {
          text-decoration: none;
          color: white;
        }

  .fa-question-circle {
    font-size: 20px;
    padding-right: 10px;
    padding-left: 10px;
  }

  #cerrarsesion {
    height: 60px;
    transition: all .3s;
  }

    #cerrarsesion:hover {
      background-color: #333333;
      cursor: pointer;
    }

  .fa-sign-out-alt {
    font-size: 20px;
    padding-right: 10px;
    padding-left: 10px;
  }

  #seccionDerecha {
    width: 10px;
  }

  .negarelclick {
    pointer-events: none;
  }

  .menu-seleccionado {
    background-color: #333333;
  }

  @media(max-width: 991px) {
    .w-50 {
      width: 100% !important;
    }

    h1 {
      border-right: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Comunes/MenuSuperior.vue